/* eslint-disable @typescript-eslint/no-explicit-any */
import {OverlayContainer} from '@angular/cdk/overlay';
import {Platform} from '@angular/cdk/platform';
import {Inject, Injectable, OnDestroy, DOCUMENT} from '@angular/core';


@Injectable()
export class NlrOverlayContainer extends OverlayContainer implements OnDestroy {
    constructor(
        @Inject(DOCUMENT) private document: Document,
        _platform: Platform
    ) {
        super(document, _platform);
    }

    override getContainerElement(): HTMLElement {
        const cdkOverlayContainerSelector = this.document.activeElement?.getAttribute('data-cdkOverlayContainerSelector');
        return cdkOverlayContainerSelector ? this.document.querySelector(cdkOverlayContainerSelector) : super.getContainerElement();
    }

    override ngOnDestroy() {
        super.ngOnDestroy();
    }
}
